import { Component, OnInit, TemplateRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
})
export class AlertComponent {
  public title: string;
  public message: string | TemplateRef<any>;

  private callbackFn: (result?: any) => void;
  constructor(public modal: NgbActiveModal) {}

  public async alert(message: string | TemplateRef<any>, title?: string) {
    this.title = title || 'Attention';
    this.message = message;
    return new Promise<any>((resolve: (result?: any) => void) => {
      this.callbackFn = (result?: any): void => {
        this.modal.close(result);
        resolve(result);
      };
    });
  }

  public close(result?: any): void {
    this.callbackFn(result);
  }

  public dissmiss(reason?: any): void {
    this.modal.dismiss(reason);
  }

  public isTemplateRef(value: any): value is TemplateRef<any> {
    return value instanceof TemplateRef;
  }
}
